import { reducerRegistry } from '../../../../reducerRegistry';

import listsReducersMap from './lists/reducersMap';
import formsReducersMap from './forms/reducersMap';
import statesReducersMap from './states/reducersMap';

const combineMap = {
  lists: listsReducersMap,
  forms: formsReducersMap,
  states: statesReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('userFlowFundsModule', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userFlowFunds/reducers/static/combineRegistry.js